import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import RCAPengajuanApprovalService from "services/Setup/RCAPengajuanApproval/RCAPengajuanApprovalService";

import { message, notification } from "antd";

export const initialState = {
  loading: false,
  loadingApprovalComponentMaster: false,
  message: "",
  statusRespon: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  RCAPengajuanApprovalList: [],
  approverDropdownList: [],
  searchApprovalStatusList: [],
  searchApprovalDetailList: [],
  getApproverLimitList: [],
  sppkKkbList: [],
};

// Async thunk functions
export const getApprovalComponentMasterSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/getApprovalComponentMasterSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.getRCAPengajuanApprovalService(
          userInput
        );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const approverDropdownSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/approverDropdownSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.approverDropdownService(userInput);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const saveRCAApprovalSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/saveRCAApprovalSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await RCAPengajuanApprovalService.saveRCAApprovalService(
        userInput
      );

      if (response.status === 200) {
        const data = response.data;
        if (data.status === "Success") {
          notification.success({
            message: data.status,
            description: data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: data.status,
            description: data.message,
            duration: 3,
          });
        }
        return data;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const searchApprovalDetailKKBSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/searchApprovalDetailKKBSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.searchApprovalDetailKKBService(
          userInput
        );

      if (response.status === 200) {
        const data = response.data;
        // if (data.status === "Success") {
        //   notification.success({
        //     message: data.status,
        //     description: data.message,
        //     duration: 3,
        //   });
        // } else {
        //   notification.error({
        //     message: data.status,
        //     description: data.message,
        //     duration: 3,
        //   });
        // }
        return data;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const saveApprovalDetailSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/saveApprovalDetailSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.saveApprovalDetailService(userInput);

      if (response.status === 200) {
        const data = response.data;
        if (data.status === "Success") {
          notification.success({
            message: data.status,
            description: data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: data.status,
            description: data.message,
            duration: 3,
          });
        }
        return data;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const searchApprovalStatusSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/searchApprovalStatusSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.searchApprovalStatusService(
          userInput
        );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

// 🔧 FIX: Ganti action type agar tidak duplikat
export const getsearchApprovalDetailSSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/getsearchApprovalDetailSSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.searchApprovalDetailService(
          userInput
        );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getApproverLimitSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/getApproverLimitSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.getApproverLimitService(userInput);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const saveApprovalDetailKKBSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/saveApprovalDetailKKBSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.saveApprovalDetailKKBService(
          userInput
        );

      if (response.status === 200) {
        const data = response.data;
        if (data.status === "Success") {
          notification.success({
            message: data.status,
            description: data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: data.status,
            description: data.message,
            duration: 3,
          });
        }
        return data;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const searchApprovalStatusKKBSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/searchApprovalStatusKKBSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.searchApprovalStatusKKBService(
          userInput
        );

      if (response.status === 200) {
        const data = response.data;

        return data;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getApproverLimitKKBSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/getApproverLimitKKBSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.getApproverLimitKKBService(userInput);

      if (response.status === 200) {
        const data = response.data;
        if (data.message === "Limit mencukupi.") {
          notification.success({
            message: 'Success',
            description: data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: 'Error',
            description: data.message,
            duration: 3,
          });
        }
        return data;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getSearchSppkListSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/getSearchSppkListSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.getSearchSppkListService(userInput);

      if (response.status === 200) {
        const data = response.data;

        return data;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getSearchSppkReportSlice = createAsyncThunk(
  "RCAPengajuanApprovalSlice/getSearchSppkReportSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await RCAPengajuanApprovalService.getSearchSppkReportService(userInput);

      if (response.status === 200) {
        const data = response.data;

        return data;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

// Slice
export const RCAPengajuanApproval = createSlice({
  name: "RCAPengajuanApproval",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetState: (state) => {
      state.loading = false;
      state.message = "";
      state.statusRespon = "";
      state.showMessage = false;
      state.redirect = "";
      state.result = {};
      state.RCAPengajuanApprovalList = [];
      state.approverDropdownList = [];
      state.searchApprovalStatusList = [];
      state.searchApprovalDetailList = [];
      state.getApproverLimitList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getApprovalComponentMasterSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getApprovalComponentMasterSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.RCAPengajuanApprovalList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getApprovalComponentMasterSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      .addCase(approverDropdownSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(approverDropdownSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.approverDropdownList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(approverDropdownSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      .addCase(saveRCAApprovalSlice.pending, (state) => {
        state.loadingBankAanalis = true;
      })
      .addCase(saveRCAApprovalSlice.fulfilled, (state, action) => {
        state.loadingBankAanalis = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(saveRCAApprovalSlice.rejected, (state, action) => {
        state.loadingBankAanalis = false;
        state.result = action.payload;
        state.showMessage = true;
        state.noApkFAS = "";
      })

      .addCase(searchApprovalStatusSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchApprovalStatusSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.searchApprovalStatusList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(searchApprovalStatusSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      .addCase(getsearchApprovalDetailSSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getsearchApprovalDetailSSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.searchApprovalDetailList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getsearchApprovalDetailSSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // getApproverLimitSlice
      .addCase(getApproverLimitSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getApproverLimitSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.getApproverLimitList = action?.payload ?? action;
        state.getCount = action.payload.count;
      })
      .addCase(getApproverLimitSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      .addCase(saveApprovalDetailSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveApprovalDetailSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.message;
        state.statusRespon = 200;
      })
      .addCase(saveApprovalDetailSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.message =
          action.payload.message || "Failed to save approval detail";
      })
      // searchApprovalStatusKKBSlice
      .addCase(searchApprovalStatusKKBSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchApprovalStatusKKBSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.searchApprovalStatusList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(searchApprovalStatusKKBSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // searchApprovalDetailKKBSlice

      .addCase(searchApprovalDetailKKBSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchApprovalDetailKKBSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.searchApprovalDetailList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(searchApprovalDetailKKBSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // getApproverLimitKKBSlice
      .addCase(getApproverLimitKKBSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getApproverLimitKKBSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.getApproverLimitList = action?.payload ?? action;
        state.getCount = action.payload.count;
      })
      .addCase(getApproverLimitKKBSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // saveApprovalDetailKKBSlice
      .addCase(saveApprovalDetailKKBSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveApprovalDetailKKBSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.message;
        state.statusRespon = 200;
      })
      .addCase(saveApprovalDetailKKBSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.message =
          action.payload.message || "Failed to save approval detail";
      })
      // getSearchSppkListSlice
      .addCase(getSearchSppkListSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSearchSppkListSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.sppkKkbList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getSearchSppkListSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // getSearchSppkReportSlice
      .addCase(getSearchSppkReportSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSearchSppkReportSlice.fulfilled, (state, action) => {
         console.log('responsepdf',action.payload);
        state.loading = false; 
        state.getCount = action.payload.count;
      })
      .addCase(getSearchSppkReportSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

// Exports
export const { showNotification, hideNotification, showLoading, resetState } =
  RCAPengajuanApproval.actions;

export default RCAPengajuanApproval.reducer;
